import { render, staticRenderFns } from "./error-reports.vue?vue&type=template&id=2ae30ee4&"
import script from "./error-reports.vue?vue&type=script&lang=js&"
export * from "./error-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports